import { default as u } from "./createSvgIcon3.mjs";
import t from "./ClassNameGenerator.mjs";
import { default as m } from "./createChainedFunction.mjs";
import { default as n } from "./debounce.mjs";
import { default as i } from "./deprecatedPropType.mjs";
import { default as c } from "./ownerWindow.mjs";
import { default as h } from "./requirePropFactory.mjs";
import { default as g } from "./setRef.mjs";
import { default as N } from "./capitalize.mjs";
import { default as _ } from "./isMuiElement.mjs";
import { default as F } from "./ownerDocument.mjs";
import { default as I } from "./useEnhancedEffect.mjs";
import { default as P } from "./useId.mjs";
import { default as k } from "./unsupportedProp.mjs";
import { default as D } from "./useControlled.mjs";
import { default as R } from "./useEventCallback.mjs";
import { default as j } from "./useForkRef.mjs";
import { default as z } from "./useIsFocusVisible.mjs";
const a = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), t.configure(e);
  }
};
export {
  N as capitalize,
  m as createChainedFunction,
  u as createSvgIcon,
  n as debounce,
  i as deprecatedPropType,
  _ as isMuiElement,
  F as ownerDocument,
  c as ownerWindow,
  h as requirePropFactory,
  g as setRef,
  a as unstable_ClassNameGenerator,
  I as unstable_useEnhancedEffect,
  P as unstable_useId,
  k as unsupportedProp,
  D as useControlled,
  R as useEventCallback,
  j as useForkRef,
  z as useIsFocusVisible
};
//# sourceMappingURL=index326.mjs.map
